import fr from 'facet-rest';
import BaseOverride from './BaseOverride';

const QualitativeQuestionOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('options', { hidden: true });

export default QualitativeQuestionOverride;
